import { ErrorBoundary } from '@warehouselogix/web-common';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './kiosk.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root element #root not found in index.html.');
}

/**
 * Composition root for the WarehouseLogix floor PWA. Providers wrap the app
 * from the outside in:
 *   ErrorBoundary (catches render failures anywhere below)
 *     → BrowserRouter (client-side routing shell)
 *       → App (device-token gate → pairing or the tool hub).
 *
 * DELIBERATELY ABSENT: MSAL AuthProvider / Entra. This is a device+PIN app; it
 * authenticates with a paired device token (x-warehouselogix-device header)
 * and never talks to Entra. (No service worker yet — offline support comes
 * with the floor build-out.)
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
